module.exports = __webpack_public_path__ + "static/BookCover-fa5deff10b28ef16e5e9d114c5a32d56.jpg";